import script from "./PolarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PolarChart.vue?vue&type=script&setup=true&lang=js"

import "./PolarChart.vue?vue&type=style&index=0&id=fb188726&scoped=true&lang=css"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb188726"]])

export default __exports__